package devxertech.com.pages.services.chatbotDevelopment.chatbot_Services

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.TeamService
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun ChatBotServicesSection(breakpoint: Breakpoint, sitePalette: SitePalette){
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 30.px,
                bottom = if (breakpoint < Breakpoint.MD) 0.px else 30.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "Customized Ai chatbot development SERVICES ",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = 18.px,
                textAlign = TextAlign.Center,
                textTransform = TextTransform.Uppercase
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "WHAT WE ",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700,
                    letterSpacing = 0.5.px
                )
                FieldTitleTextNormalSimple(
                    "OFFER?",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700,
                    letterSpacing = 0.5.px
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(bottom = if (breakpoint < Breakpoint.MD) 0.px else if (window.screen.width > 1600) 10.px else 80.px).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                TeamService(
                    image = Res.Image.ai_Chatbot,
                    title = "AI chatbot \n development",
                    description = "We offer end-to-end AI development services, " +
                            "including design, development, integration, and support." +
                            " Our intelligent virtual assistants engage users " +
                            "in meaningful conversations 24/7.",
                )
                TeamService(
                    image = Res.Image.chatbot_Design,
                    title = "Chatbot Design & Development",
                    description = "We specialize in creating chatbots designed for " +
                            "business needs. Our team collaborates to understand the brand," +
                            " goals, and challenges. We develop chatbots according to your" +
                            " brand personality alignment.",
                )
                TeamService(
                    image = Res.Image.chatbot_Multilanguage,
                    title = "Multi-language \n" +
                            "Chatbot Development",
                    description = "We can develop multilingual chatbots that can" +
                            " converse seamlessly in different languages. We provide" +
                            " localized support and enhance customer satisfaction" +
                            " across diverse markets.",
                )
                if (window.screen.width < 1600) {
                    TeamService(
                        image = Res.Image.chatbot_Integration,
                        title = "Chatbot \n Integration",
                        description = "Our integration experts ensure smooth chatbot " +
                                "integration across websites, apps, and messaging platforms." +
                                " Our chatbot integration services enhance workflow efficiency, " +
                                "providing a platform for effortless communication.",
                    )


                    TeamService(
                        image = Res.Image.nlpLogo,
                        title = "Natural Language \n" +
                                " Chatbot Development",
                        description = "Natural Language Processing Chatbot Development With advanced" +
                                " NLP capabilities, we create AI chatbots that understand users'" +
                                " complex queries, provide accurate information, provide context-aware" +
                                " interactions, and resolve customer issues effectively.",
                        modifier = Modifier.padding(bottom = 40.px)

                    )
                    TeamService(
                        image = Res.Image.chatbot_Support,
                        title = "Chatbot Maintenance \n" +
                                "and Support",
                        description = "Post-deployment, we ensure chatbots perform optimally through " +
                                "regular updates, upgrades, and issue resolution support. Our dedicated " +
                                "engineers perform monitoring and troubleshooting to optimize performance."
                    )
                }
            }
            if (window.screen.width > 1600) {
                Row(modifier = Modifier.fillMaxWidth().display(DisplayStyle.Flex)
                    .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.Center
                ) {
                    TeamService(
                        image = Res.Image.chatbot_Integration,
                        title = "Chatbot \n Integration",
                        description = "Our integration experts ensure smooth chatbot " +
                                "integration across websites, apps, and messaging platforms." +
                                " Our chatbot integration services enhance workflow efficiency, " +
                                "providing a platform for effortless communication.",
                    )
                    TeamService(
                        image = Res.Image.nlpLogo,
                        title = "Natural Language \n" +
                                " Chatbot Development",
                        description = "Natural Language Processing Chatbot Development With advanced" +
                                " NLP capabilities, we create AI chatbots that understand users'" +
                                " complex queries, provide accurate information, provide context-aware" +
                                " interactions, and resolve customer issues effectively.",

                    )
                    TeamService(
                        image = Res.Image.chatbot_Support,
                        title = "Chatbot Maintenance \n" +
                                "and Support",
                        description = "Post-deployment, we ensure chatbots perform optimally through " +
                                "regular updates, upgrades, and issue resolution support. Our dedicated " +
                                "engineers perform monitoring and troubleshooting to optimize performance."
                    )
                }
            }
        }
    }

}